import { useEffect, useMemo, useState } from "react";
import { formatErrorReport, type ErrorReportInput } from "@shared/errorReport";
import { probeDiagnostics, snapshotDiagnostics } from "@/lib/errorDiagnostics";

/**
 * "Butiran teknikal" on both error cards. A phone has no dev console, so the
 * paste is all we get back from a crash on a seller's device; it has to carry
 * enough to settle the cause without a round of questions. The network checks
 * fill in a moment after the card appears.
 */
export function ErrorDetails({
  error,
  caught,
  className = "",
}: {
  error: Error;
  caught: { at: number; componentStack?: string };
  className?: string;
}) {
  const snapshot = useMemo(() => snapshotDiagnostics(error, caught), [error, caught]);
  const [checked, setChecked] = useState<Pick<ErrorReportInput, "probes" | "serverBuild">>({});
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let live = true;
    probeDiagnostics(error).then((result) => live && setChecked(result));
    return () => {
      live = false;
    };
  }, [error]);

  const report = formatErrorReport({ ...snapshot, ...checked });

  return (
    <details className={`w-full max-w-lg text-left ${className}`}>
      <summary className="cursor-pointer text-center text-xs text-slate-400">Butiran teknikal</summary>
      <pre
        data-testid="error-report"
        className="mt-2 max-h-56 overflow-auto whitespace-pre-wrap break-words rounded-lg bg-slate-100 p-3 text-left text-[11px] leading-relaxed text-slate-600"
      >
        {report}
      </pre>
      <button
        type="button"
        onClick={() => {
          navigator.clipboard
            ?.writeText(report)
            .then(() => setCopied(true))
            .catch(() => {});
        }}
        className="mt-2 w-full rounded-lg border border-slate-300 px-3 py-1.5 text-xs font-medium text-slate-600"
      >
        {copied ? "Disalin ✓" : "Salin butiran"}
      </button>
    </details>
  );
}
